import React from 'react'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const PleaseWaitOverlay = (props: PWOverlayProps) => {
  return (
    <div
      className={classNames({
        loading: true,
        'd-none': !props.show,
        'saveWait': true
      })}>
      <div className="title"></div>
      <div className="spinner">
        <FontAwesomeIcon icon="spinner" spin />
      </div>
      <div className="message">
        { props.message }
      </div>
    </div>
  )
}

interface PWOverlayProps {
  show: boolean;
  message: string;
}

export default PleaseWaitOverlay
